import script from "./ThemeDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeDemo.vue?vue&type=script&setup=true&lang=js"

import "./ThemeDemo.vue?vue&type=style&index=0&id=5717c344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5717c344"]])

export default __exports__